<template>
  <div>
    <!-- 筛选查询 -->
    <div class="wML-screen">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>筛选查询</span>
        </div>
        <div class="wMLS-list">
          <el-form label-position="left" label-width="90px" :model="wScreen">
            <el-row :gutter="24">
              <!-- 关键字 -->
              <el-col :span="6">
                <el-form-item label="关键字">
                  <el-input style="width: 100%;" type="text" v-model="wScreen.name" placeholder="请输入礼包名称" clearable
                    @input="changeInputSearch"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <!-- 操作按钮 -->
          <el-row type="flex" justify="space-between">
            <el-col :span="20">
              <el-button size="medium" @click="resetwScreen">重置</el-button>
              <el-button size="medium" @click="submitwScreen">查询</el-button>
            </el-col>
            <div>
              <el-button type="primary" @click="addGift">添加礼包</el-button>
            </div>
          </el-row>
        </div>
      </el-card>
    </div>

    <!-- 礼包列表区域 -->
    <div class="wGoodsList-area">
      <div class="wGL-goods">
        <div class="wGLG-table">
          <el-table :data="tableGift" border style="width: 100%;">
            <el-table-column label="礼包名称" prop="name" align="center"> </el-table-column>
            <el-table-column label="数量" prop="quantity" align="center"> </el-table-column>
            <el-table-column label="会员类型" align="center">
              <template slot-scope="scope">
                <span>{{ getMembershipTypeLabel(scope.row.membershipType) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="图片" align="center">
              <template slot-scope="scope">
                <template v-if="scope.row.headImg && isImage(scope.row.headImg)">
                  <el-image style="width:80px;height:80px;" fit="contain" :src="scope.row.headImg"
                    :preview-src-list="[scope.row.headImg]"></el-image>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="updateGift(scope)"><span>修改</span></el-button>
                <el-button type="text" size="small" @click="deleteGift(scope)"><span>删除</span></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <div class="wPagination">
          <el-pagination @current-change="changePaginationCurrent" @size-change="changePaginationSize"
            :current-page="pagination.current" :page-sizes="pagination.sizes" :page-size="pagination.size"
            :total="pagination.total" layout="total, sizes, prev, pager, next, jumper">
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 添加/编辑礼包 -->
    <el-dialog width="900px" style="height: auto;" append-to-body :title="title" :visible.sync="visibleAddGift"
      :close-on-press-escape="false" :close-on-click-modal="false">
      <el-form style="height: 580px;overflow-y: auto;" :rules="rulesAddGift" ref="formAddGift" :model="formAddGift"
        label-width="100px">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="礼包名称" prop="name">
              <el-input v-model="formAddGift.name" type="text" placeholder="请输入礼包名称" maxlength="30"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="会员类型" prop="membershipType">
              <el-select v-model="formAddGift.membershipType" placeholder="请选择会员类型" clearable style="width: 100%;">
                <el-option v-for="item in membershipTypes" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="数量" prop="quantity">
              <el-input v-model.number="formAddGift.quantity" type="number" placeholder="请输入数量"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="简介" prop="info">
              <quill-editor ref="quillEditor" v-model="formAddGift.info" :options="editorOptions"
                style="height: 200px; margin-bottom: 100px;" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="礼包主图" prop="headImg">
              <el-upload ref="mainUpload" list-type="picture-card" :limit="limitMainImg" :file-list="mainFileList"
                :class="{ hide: hideMainUpload }" :action="getUploadUrl()" :before-upload="uploadBefore"
                :on-success="uploadSuccessMain" :on-remove="uploadRemoveMain" :show-file-list="true">
                <i class="el-icon-plus"></i>
                <template #file="{ file }">
                  <div class="custom-upload-item">
                    <el-image v-if="isImage(file.url)" style="width:100%;height:100%;" fit="contain" :src="file.url"
                      :preview-src-list="[file.url]">
                    </el-image>
                    <span class="el-upload-list__item-actions">
                      <span class="el-upload-list__item-delete" @click="handleRemove(file, 'zt')">
                        <i class="el-icon-delete"></i>
                      </span>
                    </span>
                  </div>
                </template>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleAddGift = false">取 消</el-button>
        <el-button type="primary" @click="submitAddGift('formAddGift')">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { memberShip_giftList, memberShip_addMembershipGift,
         memberShip_editMembershipGift, memberShip_deleteMembershipGift,
         memberShip_getGiftDetail } from '@/network/wApi';
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

export default {
  components: {
    quillEditor
  },
  data() {
    return {
      // 筛选表单
      wScreen: {
        name: null,
        pageNo: 1,
        pageSize: 20
      },

      // 会员类型选项
      membershipTypes: [
        { label: "会员", value: 814 },
        { label: "VIP会员", value: 815 },
        { label: "渠道代理", value: 816 },
        { label: "社区团长", value: 817 },
        { label: "区县代理", value: 818 },
        { label: "区县云仓", value: 819 },
        { label: "市级代理", value: 820 },
        { label: "省分公司", value: 821 },
        { label: "轻创代理", value: 822 },
        { label: "董事合伙人", value: 823 },
        { label: "开店连锁", value: 824 }
      ],

      // 富文本编辑器配置
      editorOptions: {
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote', 'code-block'],
              [{ 'header': 1 }, { 'header': 2 }],
              [{ 'list': 'ordered' }, { 'list': 'bullet' }],
              [{ 'indent': '-1' }, { 'indent': '+1' }],
              [{ 'size': ['small', false, 'large', 'huge'] }],
              [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'align': [] }],
              ['clean'],
              ['link', 'image']
            ]
          }
        },
        placeholder: '请输入简介...',
        theme: 'snow'
      },

      // 礼包数据列表
      tableGift: [],

      // 分页配置
      pagination: {
        current: 1,
        size: 20,
        sizes: [10, 20, 50, 100],
        total: 0
      },

      // 添加/修改礼包
      title: "",
      visibleAddGift: false,
      formAddGift: {
        id: null,
        name: "",
        membershipType: null,
        quantity: null,
        info: "",
        headImg: "",
        state: 1
      },

      // 表单校验
      rulesAddGift: {
        name: [{ required: true, message: '请输入礼包名称', trigger: 'blur' }],
        membershipType: [{ required: true, message: '请选择会员类型', trigger: 'change' }],
        quantity: [{ required: true, message: '请输入数量', trigger: 'blur' }],
        headImg: [{ required: true, message: '请上传礼包主图', trigger: 'change' }]
      },

      // 图片上传
      mainFileList: [],
      limitMainImg: 1,
      hideMainUpload: false
    };
  },
  created() {
    this.getGiftList(this.wScreen);
  },
  methods: {
    // 获取礼包列表数据
    getGiftList(e) {
      const params = {
        name: e.name,
        pageNo: e["pageModel.pageNo"] || this.pagination.current || 1,
        pageSize: e["pageModel.pageSize"] || this.pagination.size || 20
      };

      memberShip_giftList(params).then(res => {
        console.log("礼包列表", res);
        if (res && res.records) {
          this.tableGift = res.records;
          this.pagination.total = res.total || 0;
        } else {
          this.tableGift = [];
          this.pagination.total = 0;
        }
      });
    },
    getMembershipTypeLabel(type) {
      const target = this.membershipTypes.find(item => Number(item.value) === Number(type));
      return target ? target.label : (type || '-');
    },

    // 筛选操作
    changeInputSearch() {
      this.submitwScreen();
    },

    resetwScreen() {
      this.resetPagination();
      this.wScreen.name = null;
      this.wScreen.pageNo = this.pagination.current;
      this.wScreen.pageSize = this.pagination.size;
      this.getGiftList(this.wScreen);
    },

    submitwScreen() {
      this.resetPagination();
      this.wScreen.pageNo = this.pagination.current;
      this.wScreen.pageSize = this.pagination.size;
      this.getGiftList(this.wScreen);
    },

    // 添加礼包
    addGift() {
      this.title = "添加礼包";
      this.resetFormAddGift();
      this.visibleAddGift = true;
    },

    // 修改礼包
    updateGift(e) {
      this.title = "修改礼包";
      this.resetFormAddGift();
      memberShip_getGiftDetail({ id: e.row.id }).then(res => {
        console.log('礼包详情', res);
        if (res) {
          this.formAddGift = {
            id: res.id,
            name: res.name,
            membershipType: res.membershipType,
            quantity: res.quantity,
            info: res.info,
            headImg: res.headImg,
            state: res.state
          };
          if (res.headImg) {
            this.mainFileList = [{ url: res.headImg }];
            this.hideMainUpload = true;
          }
        }
        this.visibleAddGift = true;
      });
    },

    // 删除礼包
    deleteGift(e) {
      this.$confirm('确定要删除这个礼包吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        memberShip_deleteMembershipGift({ id: e.row.id }).then(res => {
          this.$message.success('删除成功');
          this.submitwScreen();
        });
      }).catch(() => { });
    },

    // 重置表单
    resetFormAddGift() {
      this.hideMainUpload = false;
      this.mainFileList = [];
      this.formAddGift = {
        id: null,
        name: "",
        membershipType: null,
        quantity: null,
        info: "",
        headImg: "",
        state: 1
      };
    },

    // 分页操作
    resetPagination() {
      this.pagination.current = 1;
    },
    changePaginationCurrent(e) {
      this.pagination.current = e;
      this.wScreen.pageNo = this.pagination.current;
      this.wScreen.pageSize = this.pagination.size;
      this.getGiftList(this.wScreen);
    },
    changePaginationSize(e) {
      this.pagination.current = 1;
      this.pagination.size = e;
      this.wScreen.pageNo = this.pagination.current;
      this.wScreen.pageSize = this.pagination.size;
      this.getGiftList(this.wScreen);
    },

    // 文件上传
    getUploadUrl() {
      return `${process.env.VUE_APP_URE}/file/uploadFile`;
    },
    uploadBefore(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG 或 PNG 格式!');
      }
      return isJPG;
    },
    uploadSuccessMain(file, fileList) {
      this.mainFileList = [{ url: file.data }];
      this.formAddGift.headImg = file.data;
      this.hideMainUpload = true;
      this.$refs.mainUpload.clearFiles();
    },
    uploadRemoveMain(file) {
      this.mainFileList = [];
      this.formAddGift.headImg = "";
      this.hideMainUpload = false;
    },
    handleRemove(file, type) {
      if (type === 'zt') {
        this.mainFileList = [];
        this.formAddGift.headImg = "";
        this.hideMainUpload = false;
      }
    },

    isImage(src) {
      if (!src) return false;
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'];
      const pureSrc = src.split('?')[0];
      const ext = '.' + pureSrc.split('.').pop().toLowerCase();
      return imageExtensions.includes(ext);
    },

    // 提交表单
    submitAddGift(formAddGift) {
      this.$refs[formAddGift].validate((valid) => {
        if (valid) {
          const obj = {
            name: this.formAddGift.name,
            membershipType: this.formAddGift.membershipType,
            quantity: this.formAddGift.quantity,
            info: this.formAddGift.info,
            headImg: this.formAddGift.headImg,
            state: this.formAddGift.state
          };

          if (!this.formAddGift.id) {
            memberShip_addMembershipGift(obj).then(res => {
              this.$message.success('添加成功');
              this.submitwScreen();
              this.visibleAddGift = false;
            });
          } else {
            obj.id = this.formAddGift.id;
            memberShip_editMembershipGift(obj).then(res => {
              this.$message.success('修改成功');
              this.submitwScreen();
              this.visibleAddGift = false;
            });
          }
        } else {
          this.$message.error('请完善表单内容');
          return false;
        }
      });
    }
  }
};
</script>

<style lang="less">
@import "@/assets/css/publicStyle.less";

.ql-editor {
  min-height: 100px;
}

.wML-screen {
  display: block;
  width: 100%;
  user-select: none;
  margin-bottom: 20px;

  .wMLS-list {
    display: block;
    width: 100%;
  }
}

.wGoodsList-area {
  display: block;
  width: 100%;
  padding: 20px 16px;
  box-sizing: border-box;
  background-color: #ffffff;

  .wGL-goods {
    display: block;
    width: 100%;

    .wGLG-table {
      display: block;
      width: 100%;
    }

    .wGLG-page {
      display: block;
      width: 100%;
      margin-top: 20px;
      text-align: center;
    }
  }
}

.hide .el-upload--picture-card {
  display: none !important;
}

.el-dialog__body {
  overflow-y: auto !important;
}

.el-dialog {
  margin-top: 10vh !important;
}
</style>
